module.exports = __webpack_public_path__ + "img/snap-on-smile.56652d5e.jpg";